import { render, staticRenderFns } from "./SocialPlatformLookupList.vue?vue&type=template&id=a2bb033c&lang=pug"
import script from "./SocialPlatformLookupList.vue?vue&type=script&lang=js"
export * from "./SocialPlatformLookupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports